// extracted by mini-css-extract-plugin
export default {"searchInput":"search-input_searchInput__Bydnm"};